module.exports = __webpack_public_path__ + "img/wxcode.29fef859.jpg";